var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Icon, IconName } from "@eightfold.ai/octuple";
var RightArrow = function (_a) {
    var onClick = _a.onClick;
    return (_jsx(Box, __assign({ sx: { cursor: "pointer" }, "aria-label": "go to", onClick: onClick || (function () { return undefined; }) }, { children: _jsx(Icon, { path: IconName.mdiArrowRight }) })));
};
export default RightArrow;
